import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialWhatsappIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialWhatsapp",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.88 6.09c-2.57-2.62-6.09-4.1-9.76-4.09-3.69 0-7.23 1.46-9.83 4.08-2.6 2.61-4.05 6.16-4.02 9.85.03 2.41.65 4.78 1.82 6.89l-1.97 7.19 7.34-1.89c2.02 1.11 4.28 1.68 6.58 1.66 7.66-.04 13.85-6.26 13.85-13.92.02-3.66-1.43-7.17-4.01-9.76Zm-9.76 21.34c-2.05.01-4.07-.54-5.83-1.59l-.45-.23-4.39 1.14 1.14-4.31-.3-.45c-2.45-3.95-2.28-8.98.43-12.76a11.483 11.483 0 0 1 20.66 4.85c.75 4.59-1.33 9.17-5.28 11.62a11 11 0 0 1-5.98 1.74Zm6.66-8.4-.83-.38s-1.21-.53-1.97-.91c-.08 0-.15-.08-.23-.08-.19 0-.37.06-.53.15 0 0-.08.08-1.14 1.29-.07.14-.22.23-.38.23h-.08a.57.57 0 0 1-.3-.15l-.38-.15c-.81-.34-1.56-.83-2.19-1.44-.15-.15-.38-.3-.53-.45a8.8 8.8 0 0 1-1.44-1.82l-.08-.15c-.08-.08-.08-.15-.15-.3-.02-.13 0-.26.08-.38 0 0 .3-.38.53-.61s.23-.38.38-.53a.93.93 0 0 0 .15-.76c-.35-.98-.76-1.94-1.21-2.88a.9.9 0 0 0-.53-.38h-.83c-.15 0-.3.08-.45.08l-.08.08c-.15.08-.3.23-.45.3s-.23.3-.38.45c-.53.67-.82 1.49-.83 2.35 0 .6.14 1.19.38 1.74l.08.23c.68 1.45 1.63 2.76 2.8 3.86l.3.3c.22.18.42.38.61.61 1.57 1.37 3.44 2.35 5.45 2.88.23.08.53.08.76.15h.76q.6-.03 1.14-.3c.23-.15.38-.15.53-.3l.15-.15c.15-.15.3-.23.45-.38.15-.13.28-.28.38-.45.15-.34.25-.69.3-1.06v-.53a1 1 0 0 0-.23-.15Z"
    })
  }));
};